import script from "./SwitchPatientModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchPatientModal.vue?vue&type=script&setup=true&lang=js"

import "./SwitchPatientModal.vue?vue&type=style&index=0&id=8de8f832&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8de8f832"]])

export default __exports__